import { borderRadius, colors, fontWeights } from '@/theme'
import { Box, Divider, Typography } from '@mui/material'

interface StatusFooterProps {
  status?: string
  changedBy?: string
  updatedAt?: string
  previousStatus?: string
}

export default function StatusFooter({ status, changedBy, updatedAt, previousStatus }: StatusFooterProps) {
  if (!status && !changedBy && !updatedAt && !previousStatus) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        mt: 2,
        p: 2,
        border: `1px solid ${colors.border.default}`,
        borderRadius: borderRadius.sm
      }}
    >
      {status && (
        <>
          <Box sx={{ flex: 1 }}>
            <Typography variant='fieldLabel' sx={{ display: 'block', mb: 0.5 }}>
              Status
            </Typography>
            <Typography variant='fieldValue' sx={{ fontWeight: fontWeights.semibold }}>
              {status}
            </Typography>
          </Box>
          <Divider orientation='vertical' flexItem />
        </>
      )}

      {changedBy && (
        <>
          <Box sx={{ flex: 1 }}>
            <Typography variant='fieldLabel' sx={{ display: 'block', mb: 0.5 }}>
              Changed By
            </Typography>
            <Typography variant='fieldValue' sx={{ fontWeight: fontWeights.semibold }}>
              {changedBy}
            </Typography>
          </Box>
          <Divider orientation='vertical' flexItem />
        </>
      )}

      {updatedAt && (
        <>
          <Box sx={{ flex: 1 }}>
            <Typography variant='fieldLabel' sx={{ display: 'block', mb: 0.5 }}>
              Updated
            </Typography>
            <Typography variant='fieldValue' sx={{ fontWeight: fontWeights.semibold }}>
              {updatedAt}
            </Typography>
          </Box>
          <Divider orientation='vertical' flexItem />
        </>
      )}

      {previousStatus && (
        <Box sx={{ flex: 1 }}>
          <Typography variant='fieldLabel' sx={{ display: 'block', mb: 0.5 }}>
            Previous Status
          </Typography>
          <Typography variant='fieldValue' sx={{ fontWeight: fontWeights.semibold }}>
            {previousStatus}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
